
export const clockOffset = (serverNow: number | undefined, deviceNow: number): number =>
  serverNow === undefined ? 0 : serverNow - deviceNow;

export const serverTime = (deviceNow: number, offset: number): number => deviceNow + offset;

export const secondsLeft = (deadline: number, deviceNow: number, offset: number): number =>
  Math.max(0, Math.ceil((deadline - serverTime(deviceNow, offset)) / 1000));

export const saveDelay = (
  deadline: number | undefined,
  deviceNow: number,
  offset: number,
  debounceMs: number,
): number =>
  deadline !== undefined && deadline - serverTime(deviceNow, offset) <= debounceMs * 4 ? 0 : debounceMs;
